import { combineReducers } from 'redux';
import undoableWrapper from 'redux-undo';

import { color_shuffle } from 'js/src/data/color-shuffle/color-shuffle-reducers';
import { undoable_media } from 'js/src/data/media/media-reducers';
import { undoable_transcript } from 'js/src/data/transcript/transcript-reducers';
import { user_overrides } from 'js/src/data/user-overrides/user-overrides-reducers';
import { video } from 'js/src/data/video/video-reducers';
import { video_data } from 'js/src/data/video-data/video-data-reducers';
import { undoRedoConfig } from 'js/src/libs/undo-utils';

const undoableReducers = combineReducers({
    video,
    video_data,
    user_overrides,
    media: undoable_media,
    color_shuffle,
    transcript: undoable_transcript,
});
export const undoable = undoableWrapper(undoableReducers, undoRedoConfig);
export type UndoableState = ReturnType<typeof undoable>;
